import { createFileRoute } from "@tanstack/react-router";
import AgenteRetailIA from "@/pages/AgenteRetailIA";
import { SITE_URL } from "@/lib/site-url";

/** Explainer page for the Retail AI Agent (EN). The consultation window lives at /en/retail-ai-agent. */
export const Route = createFileRoute("/en/what-is-the-retail-ai-agent")({
  head: () => {
    const title = "Retail AI Agent for street-level shops | Retail Lemon";
    const description =
      "What the Retail AI Agent is: it walks your shop, bar or street-level business through guides, a roadmap and grants for your premises. Not a generic chat: it follows your store's next step.";
    const url = `${SITE_URL}/en/what-is-the-retail-ai-agent`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
    };
  },
  component: () => <AgenteRetailIA routeLang="en" />,
});
